var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.142138 3.696C-0.047379 3.86391 -0.047379 4.13542 0.142138 4.30154L4.1744 7.87407C4.36391 8.04198 4.67036 8.04198 4.85786 7.87407C5.04536 7.70616 5.04738 7.43465 4.85786 7.26853L1.16835 3.99967L4.85786 0.730806C5.04738 0.562897 5.04738 0.291385 4.85786 0.125263C4.66835 -0.0408599 4.3619 -0.0426461 4.1744 0.125263L0.142138 3.69779V3.696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.790a86d14ca011cb9ff1dbdb9e8e063b.svg";
export { ForwardRef as ReactComponent };